export default "<div id=\"app-loading\">\n  <div class=\"loader running\">\n  </div>\n</div>  ";